import { defineChain } from 'viem';

/** Rootstock Blockscout explorer base URL (tx links: ${ROOTSTOCK_EXPLORER_URL}/tx/0x...) */
export const ROOTSTOCK_EXPLORER_URL = 'https://rootstock.blockscout.com' as const;

export const rootstock = defineChain({
  id: 30,
  name: 'Rootstock',
  nativeCurrency: {
    decimals: 18,
    name: 'RBTC',
    symbol: 'RBTC',
  },
  rpcUrls: {
    // Must be absolute for wallet connectors (e.g. wallet_addEthereumChain / WalletConnect).
    // App reads still go through wagmi transport configured as /api/rpc in shared/lib/wagmi.ts.
    default: { http: ['https://public-node.rsk.co'] },
    public: { http: ['https://public-node.rsk.co'] },
  },
  blockExplorers: {
    default: { name: 'Blockscout', url: ROOTSTOCK_EXPLORER_URL },
  },
});

export const CONTRACT_ADDRESS = '0x4d9cbe0f242eE85f7fA25C77329749381Ba998BE' as const;

/** MoneyOnChain BTC/USD oracle on Rootstock mainnet. */
export const MOC_BTC_USD_ORACLE_ADDRESS =
  '0x972a21C61B436354C0F35836195D7B67f54E482C' as const;

export const DOC_TOKEN_ADDRESS = '0xe700691dA7b9851F2F35f8b8182c69c53CcaD9Db' as const;
export const USDRIF_TOKEN_ADDRESS = '0x3A15461d8aE0F0Fb5Fa2629e9DA7D66A794a6e37' as const;

export const SUPPORTED_TOKENS = [
  { address: DOC_TOKEN_ADDRESS, name: 'DOC', decimals: 18 },
  { address: USDRIF_TOKEN_ADDRESS, name: 'USDRIF', decimals: 18 },
] as const;

export const TROPYKUS_BLOCKS_PER_YEAR = 1_051_200;

export const LENDING_CONTRACTS = {
  tropykus: {
    kDOC: '0x544eb90e766b405134b3b3f62b6b4c23fcd5fda2' as const,
    kUSDRIF: '0xDdf3CE45fcf080DF61ee61dac5Ddefef7ED4F46C' as const,
  },
  sovryn: {
    iDOC: '0xd8D25f03EBbA94E15Df2eD4d6D38276B595593c1' as const,
  },
} as const;
